import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchGetQuery, fetchGetQueryWithApiKey, fetchQueryBlob } from "../api";
import urlBuilder from "../../components/utils/dataGridURLBuilder";
import determineSorting from "../../components/utils/determineSorting";

// Custom hook to fetch paginated tenders with sorting, searching and filtering
export function useExportCsv(pagination, sorting, search, columnFilters, url) {
  const { pageIndex, pageSize } = pagination;

  // Determine sorting field and direction
  const { sortField, sortDirection } = determineSorting(sorting);

  // Filter out inactive filters (empty values)
  const activeFilters = columnFilters.filter((f) =>
    Array.isArray(f.value) ? f.value.length : f.value,
  );

  // Build URL with pagination, sorting, search and active filters

  const exportCsv = true; // Flag to indicate that this is an export request, can be used in urlBuilder if needed

  const urlBuilded = urlBuilder(
    url,
    pagination,
    sortField,
    sortDirection,
    search,
    activeFilters,
    exportCsv,
  );

  return useMutation({
    mutationFn: async () => {
      const response = await fetchQueryBlob(urlBuilded);
      // Create a URL for the blob and trigger download
      return response;
    },
    onError: (error) => {
      console.error("Error exporting CSV:", error);
    },
  });
}

//GET data for osebe from Imenik API based on search term
export const useGetOsebeFromImenik = (searchTerm) => {
  const url = `Imenik/iskalnik?search=${searchTerm}`;
  return useQuery({
    queryKey: ["osebe-imenik", searchTerm],
    queryFn: async () => {
      return fetchGetQueryWithApiKey(url);
    },
    enabled: !!searchTerm && searchTerm.length >= 3,
  });
};

//GET clanice UM sifrant
export const useGetClaniceSifrant = () => {
  const url = `sifrant/clanice`;
  return useQuery({
    queryKey: ["clanice-sifrant"],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
};

//GET VUIR sifrant for academic person types
export const useGetVuirSifrant = () => {
  const url = `sifrant/vuir-sifrant`;
  return useQuery({
    queryKey: ["vuir-sifrant"],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
};
